import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M1.247 6.667h29.527a9 9 0 0 1 .393 1.242c.382 1.587.61 3.196.728 4.758H.117c.127-1.562.367-3.182.75-4.792 0 0 .101-.487.38-1.208M.107 19.333h31.776a32 32 0 0 1-.75 4.791s-.102.488-.38 1.21H1.247a8.5 8.5 0 0 1-.38-1.21 29 29 0 0 1-.76-4.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M12.667.129v19.204H.107a37 37 0 0 1-.104-3.35c-.033-2.492.2-5.317.863-8.108 0 0 1.03-4.918 5.476-6.646C7.808.67 10.122.307 12.667.13",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m6.333 11.667-2.939 2.045 1.037-3.427-2.853-2.163 3.58-.073 1.175-3.382L7.51 8.049l3.58.073-2.853 2.163 1.036 3.427z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagTgo = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagTgo_default = SvgFlagTgo;

export { FlagTgo_default as default };
